import { handleApiResponse } from '../../handleApiResponse';
import { CustomerVerificationStatus } from './model/CustomerVerificationStatus';

export const getCustomerVerificationStatus = async (): Promise<CustomerVerificationStatus> => {
  const response = await fetch(
    new URL('/api/v1/customer/verification-status', process.env.BASE_URL || window.location.origin).toString(),
    {
      method: 'GET',
      headers: {
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json; charset=UTF-8',
      },
      credentials: 'include',
    },
  );

  handleApiResponse(response);

  return (await response.json()) as CustomerVerificationStatus;
};
